import React, { useState } from "react";

import { Dropdown } from "antd";

import TEMPLATE_TAGS_COLOR, { getTemplateAccentStyle, READ_ONLY_TEMPLATE_STYLE } from "../../helper";
import TemplateDeleteModal from "./TemplateDeleteModal";
import TemplateSectionLoading from "../Common/TemplateSectionLoading";

import { ReactComponent as PreviewPlayIcon } from "../../../../../assets/images/common/PreviewPlayIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/images/product/template/delete.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/images/product/template/edit.svg";
import { ReactComponent as OptionIcon } from "../../../../../assets/images/product/template/options.svg";
import "./TemplateCard.css";

export default function TemplateCard({
  index,
  item,
  isCreatingCoa,
  isSelected,
  saveTemplateIdForAddingCoa,
  handleEditTemplate,
  handleDeleteTemplate,
  onPreviewTemplate,
  cardActionBusy = false,
  selectBusy = false,
}) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const itemBusy = cardActionBusy || selectBusy;

  if (!item) {
    return null;
  }

  const tagStyle = TEMPLATE_TAGS_COLOR[item.tags?.[0]] || TEMPLATE_TAGS_COLOR.blue;
  const isReadOnlyTemplate = item.read_only === true;
  const hideTemplateActions = isReadOnlyTemplate;
  const backgroundColor = isReadOnlyTemplate ? undefined : tagStyle.backgroundColor;
  const boxShadow = isSelected ? tagStyle.boxShadow : "";
  const readOnlyCardStyle = isReadOnlyTemplate ? READ_ONLY_TEMPLATE_STYLE : {};
  const accentStyle = getTemplateAccentStyle(item);

  const handleSelectTemplate = () => {
    if (isCreatingCoa && !selectBusy) {
      saveTemplateIdForAddingCoa(index);
    }
  };

  const toggleShowDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const handleClickPreview = (e) => {
    if (cardActionBusy) {
      return;
    }
    const isDropdownTrigger = e.target.id === "TemplateCardDropdownTrigger" || e.target.parentNode.id === "TemplateCardDropdownTrigger";
    if (!isDropdownTrigger) {
      onPreviewTemplate();
    }
  };

  const handleOptionClick = ({ key, domEvent }) => {
    domEvent.stopPropagation();
    switch (key) {
      case "edit":
        handleEditTemplate(item.template_id);
        break;
      case "delete":
        toggleShowDeleteModal();
        break;
      default:
        break;
    }
  };

  const items = [
    {
      key: "edit",
      label: (
        <div className="TemplateCard__MenuItem">
          <EditIcon className="templateCardEditIcon" />
          <span>Edit</span>
        </div>
      ),
    },
    {
      key: "delete",
      label: (
        <div className="TemplateCard__MenuItem">
          <DeleteIcon className="templateCardDeleteIcon" />
          <span>Delete</span>
        </div>
      ),
    },
  ];

  if (isCreatingCoa) {
    return (
      <div
        className={`TemplateChooseItem${isSelected ? " TemplateChooseItem--selected" : ""}${itemBusy ? " TemplateChooseItem--loading" : ""}`}
        onClick={handleSelectTemplate}
      >
        <span className="TemplateChooseItem__Accent" style={accentStyle} />
        <span className="TemplateChooseItem__Name" title={item.name}>{item.name}</span>
        <span
          className="templateCardPlayButton"
          role="button"
          tabIndex={0}
          aria-label="Preview template"
          aria-busy={cardActionBusy}
          onClick={(e) => {
            e.stopPropagation();
            handleClickPreview(e);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              handleClickPreview(e);
            }
          }}
        >
          <span className="templateCardPlayButton__Inner">
            <PreviewPlayIcon className="templateCardPlayButton__Caret" aria-hidden />
          </span>
        </span>
        {itemBusy && <TemplateSectionLoading variant="overlay" className="TemplateCard__ItemLoading" />}
      </div>
    );
  }

  return (
    <>
      <div
        className={`templateCardContainer${itemBusy ? " templateCardContainer--loading" : ""}`}
        style={{
          ...readOnlyCardStyle,
          ...(isReadOnlyTemplate ? {} : { backgroundColor }),
          border: isReadOnlyTemplate ? READ_ONLY_TEMPLATE_STYLE.border : "1px solid #EAF0F5",
          boxShadow,
        }}
        onClick={(e) => handleClickPreview(e)}
      >
        <span className="TemplateCard__Text" title={item.name}>{item.name}</span>
        {!hideTemplateActions && (
          <Dropdown
            menu={{ items, onClick: handleOptionClick }}
            trigger={["click"]}
            overlayClassName="TemplateCard__Menu"
          >
            <OptionIcon className="templateCardOptionsIcon" id="TemplateCardDropdownTrigger" />
          </Dropdown>
        )}
        {itemBusy && <TemplateSectionLoading variant="overlay" className="TemplateCard__ItemLoading" />}
      </div>
      <TemplateDeleteModal open={showDeleteModal} toggleShowDeleteModal={toggleShowDeleteModal} handleDeleteTemplate={() => handleDeleteTemplate(item.template_id)} />
    </>
  );
}
